import { render, staticRenderFns } from "./solicitacaoLaboratorio.vue?vue&type=template&id=dbee00d8"
import script from "./solicitacaoLaboratorio.vue?vue&type=script&lang=js"
export * from "./solicitacaoLaboratorio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports